import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setCommonLimit } from 'redux/modules/app'

function decorator () {
  return ComposedComponent => {
    @connect(({ app }) => ({
        commonLimit: app.commonLimit
      }),
      { setCommonLimit })

    class TableCommon extends Component {
      static propTypes = {
        commonLimit: PropTypes.number,
        setCommonLimit: PropTypes.func
      }

      render () {
        return (
          <ComposedComponent
            {...this.props}
          />
        )
      }
    }

    return TableCommon
  }
}

export default decorator
